module.exports = __webpack_public_path__ + "img/table-no-data.png";